<template>
  <div>
    <table v-if="details">
      <tr>
        <td><label>{{ $t('generic.id') }}:</label></td>
        <td class="pl-2">{{ details.id }}</td>
      </tr>
      <tr>
        <td><label>{{ $t('seasonTickets.details.duration') }}:</label></td>
        <td class="pl-2">{{ details.duration }} {{ details.duration_unit }}</td>
      </tr>
      <tr>
        <td><label>{{ $t('seasonTickets.details.internal_name') }}:</label></td>
        <td class="pl-2">{{ details.internal_name }}</td>
      </tr>
      <tr>
        <td><label>{{ $t('seasonTickets.details.internal_description') }}:</label></td>
        <td class="pl-2">{{ details.internal_description }}</td>
      </tr>
      <tr>
        <td><label>{{ $t('seasonTickets.details.fare_group_id') }}:</label></td>
        <td class="pl-2">{{ details.fare_group_id }}</td>
      </tr>
      <tr>
        <td><label>{{ $t('seasonTickets.details.discount_id') }}:</label></td>
        <td class="pl-2">{{ details.discount_id }}</td>
      </tr>
      <tr>
        <td><label>{{ $t('seasonTickets.details.trait') }}:</label></td>
        <td class="pl-2">{{ details.trait }}</td>
      </tr>
      <tr>
        <td><label>{{ $t('seasonTickets.details.metadata') }}:</label></td>
        <td class="pl-2"><meta-data-details :data="details.metadata"/></td>
      </tr>
      <tr>
        <td><label>{{ $t('generic.created') }}:</label></td>
        <td class="pl-2">{{ details.created_at | time }}</td>
      </tr>
      <tr>
        <td><label>{{ $t('generic.createdBy') }}:</label></td>
        <td class="pl-2">{{ details.created_by }}</td>
      </tr>
      <tr>
        <td><label>{{ $t('generic.updated') }}:</label></td>
        <td class="pl-2">{{ details.updated_at | time }}</td>
      </tr>
      <tr>
        <td><label>{{ $t('generic.updatedBy') }}:</label></td>
        <td class="pl-2">{{ details.modified_by }}</td>
      </tr>
    </table>
  </div>
</template>
<script>

import MetaDataDetails from "@/components/MetaData/MetaDataDetails.vue";

export default {
  name: "SeasonTicketDetails",
  components: {MetaDataDetails},
  props: {
    details: {
      type: Object,
      required: true,
    }
  },
};
</script>
